Service = App.loadClass 'core::Angular/Service'

class exports.LocationService extends Service
    constructor: (@http) ->
        @marker_placed = false
        @all_locations = null
        @new = null
        @invalid = {}

        # Marker style definition
        @icon = new L.mapbox.marker.icon {
            'marker-size': 'large'
            'marker-color': '#3A894C'
            'marker-symbol': 'farm'
        }

        # Load the marker toolbar
        @initMarker()

    setAllLocations: () =>
        # load locations
        @loadAllLocations().then (response) =>
            @all_locations = response.data.data

    loadAllLocations: () =>
        return @http.post 'backend/grower/buyer-location/load-all', { fpcResultId: @params.fpcResultId }


    save: (fpcResultId) =>
        return @http.post 'backend/grower/buyer-location/save', { location: @new, fpcResultId }


    checkPlacement: (lat, lng) =>
        return @http.post 'backend/grower/buyer-location/check-placement', { lat: lat, long: lng }


    createNew: () =>
        @new =
            id: null,
            latitude: null,
            longitude: null,
            name: null,
            zip: null,
            admin_area_2_id: null

    nameIsUnique: (location_name) =>
        for location in @all_locations
            if location.name.toLowerCase() is location_name.toLowerCase()
                return false

        return true



    # Creates a new feature group for the marker and adds it to the map
    createFeatureGroup: () =>
        App.map.removeLayer @feature_group if @feature_group
        delete @feature_group
        @feature_group = new L.FeatureGroup()
        @feature_group.addTo App.map

    reset: () =>
        @marker_placed = false
        @all_locations = null
        @invalid = {}
        @createNew()
        @createFeatureGroup()
        @fromFpc = null
        @step = null
        @fpcResultId = null
        @existing = null
        @editing = null


    initMarker: () =>
        # Initialize the marker toolbar and add it to the map
        @drawControl = new L.Control.MfMarker()
        App.map.addControl @drawControl

        # Deselect the tool and hide the toolbar; we will turn this on and off
        # when entering/leaving the placement step
        @drawControl.deselect()
        $('.leaflet-control-container').hide()


    getCapacityUnit: () =>
        @http.post 'backend/grower/operation/get-capacity-unit'
